<i18n>
{
  "cl": {
    "title": "Evaluaciones automáticas",
    "requestOf": "Solicitud del",
    "notDefined": "No definido"
  }
}
</i18n>

<template>
  <header>
    <div id="evaluation-participants" data-cy="debtor-info">
      <div class="columns mb-4">
        <div class="column">
          <EvaluationDebtor :debtor="debtor" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import EvaluationDebtor from '@/ui/components/internal/evaluations/EvaluationDebtor.vue';

export default {
  name: 'EvaluationHeader',
  components: { EvaluationDebtor },
  props: {
    debtor: {
      type: Object,
      required: true
    }
  }
};
</script>
